import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const bonsaiStages= [
    // seedling
    { id: 0, value: 0, label: 'Seedling' },
    // development
    { id: 1, value: 1, label: 'Development' },
    //Structural
    { id: 2, value: 2, label: 'Structural' },
    // refinement
    { id: 3, value: 3, label: 'Refinement' },
    // General Guide
    { id: 4, value: 4, label: 'General' },
]

const BonsaiStagesSelect = ({ stage, handleStageChange }) => {
    return (
        <FormControl>
            <InputLabel id="stage-label">Bonsai Stage</InputLabel>
            <Select
                style={{ width: '200px' }}
                labelId="stage-label"
                id="stage-select"
                value={stage}
                onChange={handleStageChange}
            >
                {bonsaiStages.map((stage, index) => (
                    <MenuItem key={stage.id} value={stage.label}>
                        {stage.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default BonsaiStagesSelect;
